import smartlook from "smartlook-client";
import { eventbus } from "@/eventbus";
// import Vue from "vue";

if (process.env.NODE_ENV !== "development") {
    try {
        // Todo: get from ENV
        smartlook.init("3f00303c8d46caa7f0bb5f011ee7594976aa500d");

        smartlook.consentForms("Consent implied");
        smartlook.consentAPI("Consent implied");
        smartlook.consentIP("Consent implied");

        // user = okta subject
        eventbus.$on("auth:login", (user: any) => {
            // console.log(`Smartlook: identifying user as ${user.name}`);

            smartlook.identify(user.name as string, {
                name: user.name,
                oktaId: user.sub,
                userId: user.userid || "not set", // Todo: confirm this works
            });
        });
    } catch (e) {
        console.warn(e);
    }
}

// Todo: needs work -> when smartlook is not enabled, (see above), this will throw errors causing the entire thing to break
// Let's just make a very basic smartlook plugin for Vue (just a wrapper around smartlook-client)
// Vue.prototype.$smartlook = smartlook;

// declare module "vue/types/vue" {
//     interface Vue {
//         $smartlook: typeof smartlook;
//     }
// }
